/**
 * Module-level cache for the PWA flag snapshot resolved at boot.
 *
 * `main.tsx` calls `setPwaFlagsCache` after `fetchPwaFlagsOrAllOff`
 * resolves; UI components (e.g. PushSubscriptionButton) call
 * `getPwaFlagsCache` synchronously in their effects to decide whether
 * to fire feature-specific work.
 *
 * Snapshot stays for the lifetime of the page — operator toggles in
 * /admin/pwa propagate on next page load (deterministic, no live re-
 * fetches mid-session).
 */
import { PWA_FLAGS_ALL_OFF, type PwaFlagSnapshot } from "./pwa-flags";

let _cache: PwaFlagSnapshot = PWA_FLAGS_ALL_OFF;

export function setPwaFlagsCache(flags: PwaFlagSnapshot): void {
  _cache = flags;
}

export function getPwaFlagsCache(): PwaFlagSnapshot {
  return _cache;
}

/** Test-only: reset cache to all-off between tests to avoid state leakage. */
export function resetPwaFlagsCacheForTests(): void {
  _cache = PWA_FLAGS_ALL_OFF;
}
